import React from 'react';
import reduce from 'lodash/reduce';

import FacebookLoginButton from './FacebookLoginButton';
import AppleLoginButton from './AppleLoginButton';
import GoogleLoginButton from './GoogleLoginButton';
import {
    SOCIAL_EXTERNAL_IDENTITY_PROVIDER_FACEBOOK,
    SOCIAL_EXTERNAL_IDENTITY_PROVIDER_APPLE,
    SOCIAL_EXTERNAL_IDENTITY_PROVIDER_GOOGLE,
} from './constants';

import './SocialLogin.scss';

export const SOCIAL_MAP = {
    [SOCIAL_EXTERNAL_IDENTITY_PROVIDER_GOOGLE]: GoogleLoginButton,
    [SOCIAL_EXTERNAL_IDENTITY_PROVIDER_FACEBOOK]: FacebookLoginButton,
    [SOCIAL_EXTERNAL_IDENTITY_PROVIDER_APPLE]: AppleLoginButton,
};

// TODO: in SocialLogin.js we have createDeviceFingerprint on the socialProviderClick, check if it is neccessary.
const SocialLoginButtons = ({
    isCheckoutAuthenticationFlow,
    onSocialConnectVerified,
    onSocialConnectNotAuthorized,
    onSocialLogInUserAuthorized,
    handleOnLoadComplete,
    handleOnComponentUpdated,
    handleSocialProviderClick,
    onNotConnected,
    socialSSOSettings = {},
    buttonAppleText,
    buttonFBText,
    buttonGoogleText,
    asyncStrategy,
}) =>
    reduce(
        SOCIAL_MAP,
        (memo, SocialLoginButton, socialProvider) => {
            const settings = socialSSOSettings[socialProvider];

            if (settings) {
                const component = (
                    <div key={socialProvider} className="eds-l-mar-bot-2">
                        <SocialLoginButton
                            isCheckoutAuthenticationFlow={
                                isCheckoutAuthenticationFlow
                            }
                            onSocialConnectVerified={onSocialConnectVerified}
                            onSocialConnectNotAuthorized={
                                onSocialConnectNotAuthorized
                            }
                            onSocialLogInUserAuthorized={
                                onSocialLogInUserAuthorized
                            }
                            onClick={handleSocialProviderClick}
                            handleOnLoadComplete={handleOnLoadComplete}
                            handleOnComponentUpdated={handleOnComponentUpdated}
                            handleOnNotConnected={onNotConnected}
                            buttonAppleText={buttonAppleText}
                            buttonFBText={buttonFBText}
                            buttonGoogleText={buttonGoogleText}
                            asyncStrategy={asyncStrategy}
                            {...settings}
                        />
                    </div>
                );

                return [...memo, component];
            }

            return memo;
        },
        [],
    );

export default SocialLoginButtons;
